__turbopack_context__.v({
  "brandBar": "kqXr_q_brandBar",
  "brandBarClose": "kqXr_q_brandBarClose",
  "brandBarContent": "kqXr_q_brandBarContent",
  "brandBarHandle": "kqXr_q_brandBarHandle",
  "brandBarHeadline": "kqXr_q_brandBarHeadline",
  "brandBarHidden": "kqXr_q_brandBarHidden",
  "text--subheadline": "kqXr_q_text--subheadline",
});
